import { useCallback, useContext } from 'react';
import { Popper, ClickAwayListener } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { getDateRange } from '@sda/utils/date';
import { getRoundedFollowers } from '@sda/utils/string';
import { useInstanceSelector } from '@client/hooks/redux.hooks';
import { getMapHitById } from '@client/selectors/features/map';
import { ShowCallCard } from './ShowCallCard';
import { SetAnchorContext } from './SetAnchorContext';

const useStyles = makeStyles({ name: 'MapPopper' })((theme) => ({
  popover: {
    backgroundColor: 'transparent',
    borderRadius: theme.radii.large,
    zIndex: theme.zIndex.tooltip + 1,
  },
}));

interface MapPopperProps {
  readonly anchorEl: HTMLButtonElement;
  readonly anchorId: string;
}

export const MapPopper: React.FC<MapPopperProps> = ({ anchorEl, anchorId }) => {
  const { classes } = useStyles();

  const setAnchor = useContext(SetAnchorContext);
  const currentPoint = useInstanceSelector(getMapHitById, anchorId);

  const handlePinClose = useCallback(() => {
    setAnchor({ anchorId: null, anchorEl: null });
  }, [setAnchor]);

  return (
    <Popper
      id={anchorEl ? 'sda-map-result' : undefined}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      className={classes.popover}
      placement="top"
      modifiers={[
        {
          name: 'arrow',
          enabled: true,
        },
      ]}
    >
      {() => {
        if (currentPoint) {
          return (
            <ClickAwayListener
              onClickAway={handlePinClose}
              mouseEvent="onMouseDown"
              touchEvent="onTouchStart"
            >
              <ShowCallCard
                imgSrc={currentPoint.publicBeacon.profileData.publicImageUrl}
                path={`/connect/${currentPoint.objectID}`}
                title={currentPoint.publicBeacon.profileData.name}
                numReviews={currentPoint.publicBeacon.profileData.numReviews}
                score={currentPoint.publicBeacon.profileData.score}
                dateRange={getDateRange(currentPoint.publicBeacon)}
                isFeatured={currentPoint.publicBeacon.isFeatured}
                badge={currentPoint.publicBeacon.profileData.badge}
                spotifyMonthlyActiveListeners={getRoundedFollowers(currentPoint.publicBeacon.profileData.spotifyMonthlyActiveListeners, 'compact')}
              />
            </ClickAwayListener>
          );
        }

        return null;
      }}
    </Popper>
  );
};
